import { createFileRoute } from '@tanstack/react-router';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { AUTH_BASE } from '../lib/api';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  function loginWithFeishu() {
    window.location.href = `${AUTH_BASE}/api/auth/feishu/login?return=${encodeURIComponent(
      window.location.origin,
    )}`;
  }

  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <Card className="w-full max-w-sm gap-5 p-6">
        <div>
          <h1 className="text-lg font-semibold">登录</h1>
          <p className="text-muted-foreground text-sm">Smart Link 控制台</p>
        </div>
        {/* Password login stays as a break-glass on the worker (/api/auth/login),
            intentionally not exposed in the UI. */}
        <Button type="button" className="w-full" onClick={loginWithFeishu}>
          使用飞书登录
        </Button>
      </Card>
    </div>
  );
}
